/**
 * The bands held material splits into, in the order the app's details screen
 * runs its tabs: Recordings before Notes, so a workspace's notes are not read
 * among every recording it gathered.
 *
 * `space` is a thread, after the folder the vault keeps them in. A kind
 * nothing knows — no catalog row, a kind this build has not met — falls into
 * the generic band rather than being given a name here.
 */
export const GENERIC_BAND = 'sources';

export const BAND_ORDER = ['recordings', 'notes', 'threads', 'arcs', 'chats', 'nooks', GENERIC_BAND];

const BY_KIND: Record<string, string> = {
  recording: 'recordings',
  note: 'notes',
  arc: 'arcs',
  chat: 'chats',
  workspace: 'nooks',
};

/**
 * `space` is what the catalog calls BOTH a thread and an older note-shaped
 * unit — two of the workspaces' own members are files named `Note …`
 * catalogued that way — so the folder settles it and the kind alone does not.
 *
 * A kind nothing knows falls into the generic band rather than being guessed
 * at from its path: a file the catalog has not indexed yet lands there and
 * moves once it has.
 */
export function bandFor(kind: string | null, path: string): string {
  if (kind === 'space') return path.startsWith('threads/') ? 'threads' : 'notes';
  return (kind && BY_KIND[kind]) ?? GENERIC_BAND;
}
